<loading *ngIf="loading()"></loading>

<!-- <button class="btn btn-primary" (click)="requestAuthResult()">Send Message</button> -->

<div class="header">
    <div class="semear-logo"></div>
</div>

<!-- ESTANDO AUTENTICADO -->
<div class="container" *ngIf="authenticated">
    <div class="wopper">
        <div class="row mb-3 mt-3 banner" *ngIf="bannerIsVisible">
            <div class="col-12">
                <h1 class="text-center">Pagamento com carnê digital</h1>
                <h3 class="text-center mt-3">Opção oferecida em parceria com o Banco SEMEAR</h3>
                <h2 class="text-center mt-3 fw-800" *ngIf="titleIsVisible">Vamos lá? Selecione uma das opções:</h2>
            </div>
        </div>

        <router-outlet></router-outlet>
    </div>
</div>
<!-- FINAL ESTANDO AUTENTICADO -->

<!-- SESSÃO EXPIRADA -->
<div class="container wopper" id="isNotAuthenticated" *ngIf="!authenticated" style="justify-content: center; min-height: 70vh; display: flex;">
    <!-- *ngIf="invalidAccessToken" -->
    <div class="row">
        <div class="col-12 text-center" style="display: flex; align-items: center; justify-content: center; ">
            <h1>Sua sessão expirou, tente novamente ou entre em contato conosco!</h1>
        </div>
    </div>
</div>
<!-- FINAL SESSÃO EXPIRADA -->